import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import About from '../views/About.vue'
import Form from '../views/Forms.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Project from '../views/Projects.vue'
import auth from '../lib/auth'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    component: About
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter (to: Route, from: Route, next: Function) {
      console.log('logout')
      auth.logout()
      store.dispatch('logout')
      next('/login')
    }
  },
  {
    path: '/forms',
    name: 'Forms',
    component: Form
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Project
  },
]

const router = new VueRouter({
  routes
})

export default router
